import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav id="menu" className={`nav-bar${scrolled ? " nav-bar--scrolled" : ""}`}>
      <div className="nav-container">
        <Link className="nav-logo" to={{ pathname: "/", hash: "#page-top" }}>
          <img src="/img/logo-color.png" alt="Enteranet" />
        </Link>

        <button
          className={`nav-toggle${menuOpen ? " nav-toggle--open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`nav-links${menuOpen ? " nav-links--open" : ""}`}>
          <Link to={{ pathname: "/", hash: "#about" }} className="nav-link" onClick={() => setMenuOpen(false)}>
            About
          </Link>
          <Link to={{ pathname: "/", hash: "#services" }} className="nav-link" onClick={() => setMenuOpen(false)}>
            Solutions
          </Link>
          <Link to={{ pathname: "/", hash: "#portfolio" }} className="nav-link" onClick={() => setMenuOpen(false)}>
            Projects
          </Link>
          <Link to="/government-contracts" className="nav-link" onClick={() => setMenuOpen(false)}>
            Gov Contracts
          </Link>
          <Link to={{ pathname: "/", hash: "#training" }} className="nav-link" onClick={() => setMenuOpen(false)}>
            Process
          </Link>
          <Link to={{ pathname: "/", hash: "#contact" }} className="nav-cta" onClick={() => setMenuOpen(false)}>
            Get a Quote
          </Link>
        </div>
      </div>
    </nav>
  );
};
